import { Space } from 'antd';
import { militaryTimeString } from '../../lib/utils/date-time';
import type { ShiftPeriod, ShiftBackgroundColours } from './types';

type TimeDisplayProps = {
  /**
   * The designated 'day shift' time period
   */
  readonly dayShiftPeriod: ShiftPeriod;
  /**
   * The colours to represent day and night
   */
  readonly shiftBackgroundColours: ShiftBackgroundColours;
  readonly floatLeft?: boolean;
};

/**
 * A visual marker for what the day and night shift period times are.
 * @param props Time display component props.
 * @returns A coloured square and accompanying time ranges for the given day shift and calculated night shift period.
 */
const TimeDisplay = ({
  dayShiftPeriod,
  shiftBackgroundColours,
  floatLeft = false,
}: TimeDisplayProps) => {
  const dayTime = militaryTimeString(dayShiftPeriod.start);
  const nightTime = militaryTimeString(dayShiftPeriod.end);
  return (
    <Space
      data-cy="shift-period-time-display"
      style={{ float: floatLeft ? 'left' : 'right' }}
    >
      {['Day', 'Night'].map((period, i) => {
        return (
          <Space key={i}>
            <div
              style={{
                width: '20px',
                height: '20px',
                backgroundColor:
                  period === 'Day'
                    ? shiftBackgroundColours.day
                    : shiftBackgroundColours.night,
                border: '1px solid black',
              }}
            />
            {period}
            {period === 'Day'
              ? `(${dayTime}-${nightTime})`
              : `(${nightTime}-${dayTime})`}
          </Space>
        );
      })}
    </Space>
  );
};

export default TimeDisplay;
